import axios from 'axios';
import { notificationTypes, userTypes } from './_actionTypes';

const fetchNotifications = () => async dispatch => {
    const res = await axios.get('/api/notifications');
    dispatch({
        type: userTypes.UPDATE_NOTIFICATIONS,
        payload: {}
    });
    dispatch({type: notificationTypes.FETCH_NOTIFICATIONS, payload: res.data});
}

export const notificationActions = {
    fetchNotifications
}


// WEBPACK FOOTER //
// ./src/actions/notification.actions.js